/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from 'react';
import {
  Asset,
  EntityStatus,
  TimeLineEventType,
  TimeLineType,
  Timeline,
  TimelineEvent,
  TimelineResources,
  TimelineStep,
  TrackingFamily,
  useTimeLine,
} from '@facephi/inphinite-common';
import { Label, Spinner, useTimezone } from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import { AssetFile } from './AssetFile';
import { ModalOperationsDetail } from './ModalOperationsDetail';
import { FamilyTimeline, TimelineWrapper } from './Styles';
import { manualValidations } from '../../state/model';

type IProps = {
  onboardingId: string;
  disabled?: boolean;
  family?: string;
};

export const OperationTimeline = ({
  onboardingId,
  disabled,
  family,
}: IProps) => {
  const { events, eventMessage, loadingEvents } = useTimeLine(
    onboardingId,
    family
  );
  const [item, setItem] = useState<Asset | null>();
  const { formatTimezone } = useTimezone();
  const { t } = useTranslation();

  if (loadingEvents) {
    return <Spinner insideComponent />;
  }

  return (
    <TimelineWrapper flex="1">
      <Timeline>
        <FamilyTimeline
          color={family === TrackingFamily.ONBOARDING ? 'purple' : 'blue'}
        >
          <Label
            color={
              family === TrackingFamily.ONBOARDING ? 'purple400' : 'blue400'
            }
            fontSize="12"
            semibold={true}
          >
            {t(family as string)}
          </Label>
        </FamilyTimeline>
        {events.map((item: TimelineEvent, index: number) => {
          const itemDate = item?.date || item?.clientTimestamp;

          const source = manualValidations.includes(
            (item.metadata.source as string)?.toLowerCase()
          )
            ? t('Morphological validation')
            : (item.metadata.source as string);
          return (
            <TimelineStep
              testId="timeline-step"
              message={eventMessage(
                item.metadata.event as TimeLineEventType,
                item.metadata.screen as string,
                item.metadata.value as string,
                item.metadata.type as string,
                item.metadata.reason as string,
                item.metadata.diagnostic as any,
                item.metadata.authStatus as any,
                item.metadata.status as string,
                source || '',
                item.metadata.walletId as string,
                item.metadata.credentialType as string
              )}
              isSuccess={
                (item.metadata.type === TimeLineType.operationResult &&
                  !item.metadata.reason &&
                  item.metadata.status === EntityStatus.succeeded) ||
                ((item.metadata.type === TimeLineType.securityInfoData &&
                  item.metadata.succeed) as boolean)
              }
              isError={
                (item.metadata.type === TimeLineType.operationResult &&
                  item.metadata.reason !== null) ||
                (item.metadata.type === TimeLineType.operationResult &&
                  item.metadata.status !== EntityStatus.succeeded) ||
                (item.metadata.type === TimeLineType.securityInfoData &&
                  !item.metadata.succeed)
              }
              timeUpdate={formatTimezone(itemDate as string)}
              separation={'20px'}
              key={index}
            >
              {item.metadata.type === TimeLineType.asset && (
                <TimelineResources
                  imageComponent={<AssetFile asset={item.metadata as Asset} />}
                  name={item.metadata.type}
                  onClick={() => setItem(item.metadata as Asset)}
                  disabled={disabled}
                />
              )}
            </TimelineStep>
          );
        })}
      </Timeline>
      {item && (
        <ModalOperationsDetail
          source={item.url}
          show={!!item}
          mimeType={item.contentType}
          title={item.type}
          onChangeShow={(value) => !value && setItem(null)}
        />
      )}
    </TimelineWrapper>
  );
};
